// extracted by mini-css-extract-plugin
export default {"textLogo":"nav_textLogo__Uo4gV","active":"nav_active__qL1Zr"};